import App from "../../services/App/App.js";
import AppCatalog from "../../services/App/AppCatalog.js";
import StclItemCatalog from "./StclItemCatalog.js";

export default {
  getItemInfo(userItem) {
    let infoList = [];

    // deleted item
    if (!userItem.DispatchIsActive) {
      infoList.push(AppCatalog.Info.DeletedItem);
    }

    else {
      // SKU
      infoList.push(StclItemCatalog.SKU.Label + ": " +
        App.Value.getValue("SKU", userItem, StclItemCatalog)
      );

      // DispatchSellPrice
      infoList.push(StclItemCatalog.DispatchSellPrice.Label + ": " +
        App.Value.getValue("DispatchSellPrice", userItem, StclItemCatalog)
      );
    }

    return infoList;
  }
}